// CUSTOM: personalised-config.js

/**
 * Global configuration values for personalised bundle functionality
 * This file should be loaded before any other personalised-* files
 */

(function() {
  // Ensure namespace exists and is initialized properly
  window.personalised = window.personalised || {};
  window.personalised.config = window.personalised.config || {};
  // Define config object with default values first
  const configObject = {
    /*
     * TERMINOLOGY REFERENCE
     * ---------------------
     * Personalised Pack   — the subscription product the customer builds (avoid: bundle product, parent product)
     * subscription        — the customer's Recharge subscription record (avoid: pack in code)
     * bundle items        — the individual products inside the pack (avoid: selections, children in code)
     * guest mode          — user is not logged in (config.modes.GUEST = 'guest')
     * new mode            — user is logged in but has no active subscription (config.modes.NEW = 'new')
     * edit mode           — user is logged in with an active subscription (config.modes.EDIT = 'edit')
     * cart sync           — the process of rebuilding cart line items from bundle state (avoid: cart refresh, cart rebuild in comments)
     */

    // Mode constants for consistent usage
    modes: {
      GUEST: 'guest',
      NEW: 'new',
      EDIT: 'edit'
    },

    // API & Endpoints
    api: {
      cart: '/cart.js',
      cartAdd: '/cart/add.js',
      cartUpdate: '/cart/update.js'
    },
    
    // Subscription related constants
    subscription: {
      DEFAULT_SELLING_PLAN_LABELS: {
        '30': '30_day_subscription',
        '60': '60_day_subscription_with_15%_discount',
        '90': '90_day_subscription_with_20%_discount'
      },
      // Discount values for different frequencies
      discounts: {
        30: 0, // No discount for 30 days
        60: 0.15, // 15% discount for 60 days
        90: 0.20 // 20% discount for 90 days
      }
    },
      // Bundle properties
    bundle: {
      BUNDLE_PARENT_PROPERTY_KEY: 'personalised-pack',
      // Centralized Recharge property keys for consistent usage across files
      RECHARGE_KEYS: {
        BUNDLE_PARENT_PROPERTY: '_rc_bundle_parent',
        VARIANT_PARENT_PROPERTY: '_rc_variant_parent',
        BUNDLE_INDEX_PROPERTY: '_rc_bundle_index',
        BUNDLE_PROPERTY: '_rc_bundle',
        BUNDLE_VARIANT_PROPERTY: '_rc_bundle_variant'
      },
      // Static Recharge bundle collection values
      RECHARGE: {
        COLLECTION_ID: '512297271595', // "Personalised" Recharge bundle collection
        COLLECTION_SOURCE: 'shopify'
      }
    },
    
    // UI labels for consistent text display
    uiLabels: {
      addToPack: 'Add to Pack',
      noProductsFound: 'No products found for this goal.',
      errorMessage: 'Something went wrong and we couldn\'t update your pack. Refresh the page to try again',
      errorClose: 'Close',
      bundleItemAdded: '✅ Added to your personalised pack',
      bundleLoadingError: 'Bundle UI module not loaded properly. Please refresh the page.',
      soldOut: 'Sold Out',
      added: 'Added',
      loading: 'Loading product data...'
    },
    
    // Page routes used for navigation and routing checks
    routes: {
      review: '/pages/review-pack',
      reviewV1: '/pages/personalised-review',
      reviewV2: '/pages/review-pack',

      library: '/pages/library-v2',
      libraryV1: '/pages/personalised-library',
      libraryV2: '/pages/library-v2',

      managePack: '/pages/manage-pack',
      account: '/account',
      cart: '/cart'
    },

    // Retry settings for fetch operations
    retry: {
      maxAttempts: 3,
      baseDelay: 1000 // Base delay (ms) before exponential backoff
    },

    // Global toggle for all Afterpay checkout surfaces in the storefront theme.
    // Default OFF for subscription checkout.
    afterpayEnabled: false,

    // Tapcart-specific settings
    tapcart: {
      refreshThrottle: 3000, // Min ms between page refreshes in Tapcart
      authCooldown: 3000     // Min ms between Tapcart.authenticate() calls
    },

    // Timing values for animations, delays, and polling
    timing: {
      buttonFeedbackDuration: 300,
      mobileBreakpoint: 900,
      operationTimeout: 30000, // 30 seconds timeout for cart operations
      cartSyncDebounce: 300,   // Debounce delay (ms) for outer cart sync trigger (increased from 10ms in PR-2.1)
      syncRecencyThresholdMs: 60000 // PR-2.4: Max age (ms) of last sync timestamp for review-page skip guard
    },

    // PR-5.1: Feature flags for gradual feature activation.
    // Default all flags OFF. Change only in staging for controlled rollout.
    features: {
      // When false: single review page, current behaviour fully preserved.
      // When true: personalised-review-manager.js routes guest/new users to /pages/personalised-review
      // and edit users to /pages/manage-pack. PR-5.2 implementation is complete.
      // Requires /pages/manage-pack to exist in Shopify admin before activating.
      splitReviewExperience: true,
      // CUSTOM: The V1/V2 age-based route experiment is retired; all users resolve to V2.
      abTestReviewPage: false
    },
    
    // DOM selectors for common elements
    selectors: {
      productCard: '.personalised-library-product-card',
      actionButton: '.personalised-library-action-btn[data-add-to-pack]',
      contentColumn: '.personalised-library-content-column',
      groupsContainer: '.personalised-library-groups',
      goalButton: '.personalised-library-goal-btn',
      goalsList: '.personalised-library-goals-list',
      goalsHeading: '.personalised-library-goals-heading',
      errorModalId: 'personalised-bundle-error-modal',
      // Additional selectors from other files
      productTitle: '.personalised-library-product-title',
      productNickname: '.personalised-library-product-nickname',
      productDescription: '.personalised-library-product-description',
      productImage: '.personalised-library-product-image',
      productLink: '.personalised-library-product-link',
      productPrice: '.personalised-library-product-price span'
    },
    
    // Data attributes used for element selection
    dataAttributes: {
      variantId: 'data-variant-id',
      productId: 'data-product-id',
      collectionId: 'data-collection-id',
      available: 'data-available',
      addToPack: 'data-add-to-pack',
      removeFromPack: 'data-remove-from-pack',
      variantSelect: 'data-variant-select'
    },
    
    // URL parameter utilities
    urlUtils: {
      /**
       * Extracts mode and subscription_id from URL parameters
       * @returns {Object} Object containing mode and subscriptionId from URL
       */
      getUrlParameters: function() {
        try {
          const params = new URLSearchParams(window.location.search);
          return {
            mode: params.get('mode'),
            subscriptionId: params.get('subscription_id')
          };
        } catch (e) {
          console.warn('Failed to parse URL parameters:', e);
          return { mode: null, subscriptionId: null };
        }
      },
      
      /**
       * Validates if the provided mode matches a known mode in config.modes
       * @param {string} mode - The mode to validate
       * @returns {boolean} True if mode is valid, false otherwise
       */
      isValidMode: function(mode) {
        if (!mode) return false;
        const validModes = Object.values(window.personalised.config.modes);
        return validModes.includes(mode.toLowerCase());
      }
    }
  };
  
  /**
   * Utility function to get multiplier value based on frequency
   * @param {string|number} frequency - The frequency value ('30', '60', '90')
   * @returns {number} - Returns multiplier value: 1 for 30 days, 2 for 60 days, 3 for 90 days
   */
  function getFrequencyMultiplier(frequency) {
    // Convert any input to string for consistent comparison
    const freq = typeof frequency === 'string' ? frequency : String(frequency);
    return freq === '30' ? 1 : freq === '60' ? 2 : 3;
  }

  function instrumentAfterpayAssignment(payload) {
    try {
      var source = (payload && payload.source) ? String(payload.source) : 'unknown';
      var variant = (payload && payload.variant) ? String(payload.variant) : 'hide';
      var reason = (payload && payload.reason) ? String(payload.reason) : 'config_disabled';
      var dedupeKey = 'personalised:afterpay-assignment:' + source + ':' + window.location.pathname;

      if (sessionStorage.getItem(dedupeKey) === variant) {
        return;
      }
      sessionStorage.setItem(dedupeKey, variant);

      var detail = {
        experiment: 'afterpay_visibility',
        variant: variant,
        reason: reason,
        source: source,
        path: window.location.pathname,
        afterpayEnabled: window.personalised.config.afterpayEnabled === true,
        timestamp: Date.now()
      };

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'personalised_afterpay_assignment' }, detail));
      }

      window.dispatchEvent(new CustomEvent('personalised:afterpay-assignment', { detail: detail }));
    } catch (e) {
      // Never block page logic due to analytics/instrumentation.
    }
  }

  function getAfterpayAssignment(context) {
    var source = (context && context.source) ? String(context.source) : 'unknown';
    var enabled = window.personalised.config.afterpayEnabled === true;
    var variant = enabled ? 'show' : 'hide';
    var reason = enabled ? 'config_enabled' : 'config_disabled';

    instrumentAfterpayAssignment({
      source: source,
      variant: variant,
      reason: reason
    });

    return variant;
  }

  function shouldShowAfterpay(context) {
    return getAfterpayAssignment(context) === 'show';
  }
    // Store the function in the config namespace as the single source of truth
  window.personalised.config.getFrequencyMultiplier = getFrequencyMultiplier;
  window.personalised.config.getAfterpayAssignment = getAfterpayAssignment;
  window.personalised.config.shouldShowAfterpay = shouldShowAfterpay;
  
  // Add the utility to the configObject as well
  configObject.getFrequencyMultiplier = getFrequencyMultiplier;
  configObject.getAfterpayAssignment = getAfterpayAssignment;
  configObject.shouldShowAfterpay = shouldShowAfterpay;
  
  // Assign to single namespace
  window.personalised.config = Object.assign(window.personalised.config, configObject);
})();
